import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  EditPurchaseCart,
  clearError,
  clearMessage,
} from "../redux/manageProductSlice";

const EditPurchaseModel = ({ visible, onCancel, product }) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(product.quantity);
  const [unitsInPack, setUnitsInPack] = useState(product.unitsInPack);
  const [purchasePricePack, setPurchasePricePack] = useState(product.purchasePricePack);
  const [purchasePriceUnit, setPurchasePriceUnit] = useState(product.purchasePriceUnit);
  const [sellingPricePack, setSellingPricePack] = useState(product.sellingPricePack);
  const [sellingPriceUnit, setSellingPriceUnit] = useState(product.sellingPriceUnit);
  const { loading, error, message } = useSelector((state) => state.manageProduct);

  const confirmSellProduct = () => {
    const stockData = {
      id: product.id,
      quantity,
      unitsInPack,
      purchasePricePack,
      purchasePriceUnit,
      sellingPricePack,
      sellingPriceUnit,
    };
    dispatch(EditPurchaseCart(stockData));
    onCancel();
  };

  useEffect(() => {
    if (error) {
      alert(error);
      dispatch(clearError());
    }
    if (message) {
      alert(message);
      dispatch(clearMessage());
    }
  }, [error, message, dispatch]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full sm:w-1/2">
        <div className="text-center mb-4">
          <h3 className="text-lg font-semibold">
            Purchase {product.productName}
          </h3>
          <p className="text-gray-600 mt-2">Enter quantity and new price</p>
          <p className="text-gray-600 mt-2">
            Stock: {product.packStock}.{product.unitStock} qty
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-gray-700 mt-4 block">Quantity</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              placeholder="Enter quantity"
              className="w-full border p-2 rounded-lg mt-2"
            />
          </div>
          <div>
            <label className="text-gray-700 mt-4 block">Units per Pack</label>
            <input
              type="number"
              value={unitsInPack}
              onChange={(e) => setUnitsInPack(Number(e.target.value))}
              placeholder="Enter units per pack"
              className="w-full border p-2 rounded-lg mt-2"
            />
          </div>
          <div>
            <label className="text-gray-700 mt-4 block">Purchase Price (Pack)</label>
            <input
              type="number"
              value={purchasePricePack}
              onChange={(e) => setPurchasePricePack(Number(e.target.value))}
              placeholder="Enter price per pack"
              className="w-full border p-2 rounded-lg mt-2"
            />
          </div>
          <div>
            <label className="text-gray-700 mt-4 block">Purchase Price (Unit)</label>
            <input
              type="number"
              value={purchasePriceUnit}
              onChange={(e) => setPurchasePriceUnit(Number(e.target.value))}
              placeholder="Enter price per unit"
              className="w-full border p-2 rounded-lg mt-2"
            />
          </div>
          <div>
            <label className="text-gray-700 mt-4 block">Selling Price (Pack)</label>
            <input
              type="number"
              value={sellingPricePack}
              onChange={(e) => setSellingPricePack(Number(e.target.value))}
              placeholder="Enter selling price per pack"
              className="w-full border p-2 rounded-lg mt-2"
            />
          </div>
          <div>
            <label className="text-gray-700 mt-4 block">Selling Price (Unit)</label>
            <input
              type="number"
              value={sellingPriceUnit}
              onChange={(e) => setSellingPriceUnit(Number(e.target.value))}
              placeholder="Enter selling price per unit"
              className="w-full border p-2 rounded-lg mt-2"
            />
          </div>
        </div>

        <div className="flex justify-center mt-6 space-x-4">
          <button
            onClick={onCancel}
            className="px-6 py-2 bg-gray-300 rounded-lg text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={confirmSellProduct}
            className="px-6 py-2 bg-indigo-600 rounded-lg text-white"
          >
            {loading ? "...Loading" : "Confirm"}
          </button>
        </div>

        <div className="border-t-2 border-gray-600 w-full mt-6 pt-4">
          <div className="grid grid-cols-4 text-sm font-semibold mb-2">
            <span>Name</span>
            <span>Quantity</span>
            <span>Price/Unit</span>
            <span>Total</span>
          </div>
          <div className="grid grid-cols-4 text-sm">
            <span>{product.product_name}</span>
            <span>{quantity}</span>
            <span>{purchasePricePack}</span>
            <span>{quantity * purchasePricePack}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPurchaseModel;
